import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-semibold transition-all duration-150 ease-in-out focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring/30 focus-visible:ring-offset-1 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default:
          "bg-[#1e3a5f] text-white shadow-sm hover:bg-[#16304f] active:bg-[#122845]",
        destructive:
          "bg-[#b91c1c] text-white shadow-sm hover:bg-[#991b1b] active:bg-[#7f1d1d]",
        success:
          "bg-[#15803d] text-white shadow-sm hover:bg-[#166534] active:bg-[#14532d]",
        warning:
          "bg-[#d97706] text-white shadow-sm hover:bg-[#b45309] active:bg-[#92400e]",
        outline:
          "border-2 border-slate-200 bg-transparent text-slate-700 shadow-sm hover:bg-slate-50 hover:border-slate-300 active:bg-slate-100",
        secondary:
          "bg-slate-100 text-slate-700 shadow-sm hover:bg-slate-200 active:bg-slate-300",
        ghost:
          "text-slate-600 hover:bg-slate-100 hover:text-slate-900",
        link:
          "text-[#1e3a5f] underline-offset-4 hover:underline",
      },
      size: {
        default: "h-9 px-4 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-10 rounded-md px-8",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className }))}
      ref={ref}
      {...props} />
  );
})
Button.displayName = "Button"

export { Button, buttonVariants }
